module.exports = __webpack_public_path__ + "img/Inventory Management.a1e664ff.jpg";